export default __webpack_public_path__ + "static/interior-design-327e0b7c4ea508ba87318dbe51ac184b.png";